let navGuardConfirmMixin = {
    data() {
        return {
            isDirty: false,
        }
    },
    methods: {
        confirmLeave() {
            return window.confirm('Do you really want to leave? you have unsaved changes!')
        },
        confirmStayInDirtyForm() {
            return this.isDirty && !this.confirmLeave()
        },
        beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
                // Cancel the event
                e.preventDefault()
                // Chrome requires returnValue to be set
                e.returnValue = ''
            }
        },
        handleIsDirtyChange(isDirty) {
            this.isDirty = isDirty
        },
    },
    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
    beforeRouteUpdate(to, from, next) {
        if (this.isDirty) {
            this.$confirm({
                title: 'Unsaved Changes',
                body: 'Are you sure you want to leave?',
                confirmButtonText: 'Leave',
                cancelButtonText: 'Stay',
            })
                .then(confirmResult => next(confirmResult))
                .catch(function() {
                    next(false)
                })
        } else {
            next()
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isDirty) {
            this.$confirm({
                title: 'Unsaved Changes',
                body: 'Are you sure you want to leave?',
                confirmButtonText: 'Leave',
                cancelButtonText: 'Stay',
            })
                .then(confirmResult => next(confirmResult))
                .catch(function() {
                    next(false)
                })
        } else {
            next()
        }
    },
}

export default navGuardConfirmMixin
